<template>
    <div class="ele-body">
        <el-card shadow="never">
            <!-- 搜索表单 -->
            <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                <el-row :gutter="15">

                    <el-form-item label="用户:">
                        <el-select v-model="table.where.user_id" filterable placeholder="请选择">
                            <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学校:">
                        <el-select v-model="table.where.school_id" filterable placeholder="请选择">

                            <el-option v-for="item in campus_school_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态:">
                        <el-select v-model="table.where.status" filterable placeholder="请选择">
                            <el-option label="待支付" value="1"></el-option>
                            <el-option label="已支付" value="2"></el-option>
                            <el-option label="已接单待配送" value="3"></el-option>
                            <el-option label="配送中" value="4"></el-option>
                            <el-option label="已完成" value="5"></el-option>
                            <el-option label="已撤销" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="总金额:">
                        <el-input-number v-model="table.where.total" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入总金额"
                            clearable />
                    </el-form-item>

                    <el-form-item label="订单号:">
                        <el-input v-model="table.where.out_pay_num" placeholder="请输入订单号" clearable />
                    </el-form-item>
                    <el-form-item label="微信订单号:">
                        <el-input v-model="table.where.wx_pay_num" placeholder="请输入微信订单号" clearable />
                    </el-form-item>
                    <el-form-item label="支付类型:">
                        <el-select v-model="table.where.pay_type" filterable placeholder="请选择">
                            <el-option label="微信" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单类型:">
                        <el-select v-model="table.where.order_type" filterable placeholder="请选择">
                            <el-option label="快递代取" value="1"></el-option>
                            <el-option label="专属跑腿" value="2"></el-option>
                            <el-option label="代买" value="3"></el-option>
                            <el-option label="洗鞋" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="加急金额:">
                        <el-input-number v-model="table.where.urgent_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入加急金额"
                            clearable />
                    </el-form-item>

                    <el-form-item label="赏金:">
                        <el-input-number v-model="table.where.reward_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入赏金"
                            clearable />
                    </el-form-item>

                    <el-form-item label="创建时间:">
                        <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>



                    <el-form-item>
                        <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                            class="ele-btn-icon">查询
                        </el-button>
                        <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                        <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                            v-if="permission.includes('sys:campusboxorder:export')">导出数据
                        </el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            <!-- 操作按钮 -->

            <div class="ele-table-tool ele-table-tool-default">
                <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                    class="ele-btn-icon" size="small">刷新
                </el-button>
                <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:campusboxorder:add')">添加
                </el-button>
                <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                    v-if="permission.includes('sys:campusboxorder:dall')">批量删除
                </el-button>
                <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                    @click="search_show=!search_show">搜索</el-button>
            </div>

            <!-- 数据表格 -->
            <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                highlight-current-row>
                <template slot-scope="{index}">
                    <el-table-column type="selection" width="45" align="center" fixed="left" />
                    <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                        show-overflow-tooltip />

                    <el-table-column prop="user_id" label="用户" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.user_id_info" :key="index">{{item.nick_name+item.phone}}
                            </el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="school_id" label="学校" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-for="(item,index) in row.school_id_info" :key="index">{{item.title}}</el-tag>
                        </template>
                    </el-table-column>


                    <el-table-column prop="status" label="订单状态" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                :inactive-value="0" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="total" label="总金额" sortable="custom" show-overflow-tooltip min-width="120" />

                    <el-table-column prop="out_pay_num" label="订单号" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="wx_pay_num" label="微信订单号" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="pay_type" label="支付类型" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.pay_type == 1" :key="index">微信</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="order_type" label="订单类型" show-overflow-tooltip min-width="250">
                        <template slot-scope="{row}">
                            <el-tag v-if="row.order_type == 1" :key="index">快递代取</el-tag>
                            <el-tag v-if="row.order_type == 2" :key="index">专属跑腿</el-tag>
                            <el-tag v-if="row.order_type == 3" :key="index">代买</el-tag>
                            <el-tag v-if="row.order_type == 4" :key="index">洗鞋</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column prop="urgent_price" label="加急金额" sortable="custom" show-overflow-tooltip
                        min-width="120" />

                    <el-table-column prop="reward_price" label="赏金" sortable="custom" show-overflow-tooltip
                        min-width="120" />


                    <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                        <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                        <template slot-scope="{row}">
                            <!-- <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                v-if="permission.includes('sys:campusboxorder:edit')">修改</el-link> -->
                            <el-popconfirm title="确定要删除此快递订单吗？" @confirm="remove(row)" class="ele-action">
                                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                    v-if="permission.includes('sys:campusboxorder:delete')">删除</el-link>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </template>
            </ele-data-table>
        </el-card>
        <!-- 编辑弹窗 -->
        <el-dialog :title="editForm.id?'修改快递订单':'添加快递订单'" :visible.sync="showEdit" width="800px"
            :destroy-on-close="true" :lock-scroll="false" @close="closeDialog">
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">


                <el-form-item label="用户:" prop="user_id">
                    <el-select v-model="editForm.user_id" filterable placeholder="请选择">
                        <el-option v-for="item in user_list" :key="item.id" :label="item.nick_name+item.phone"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label="学校:" prop="school_id">
                    <el-select v-model="editForm.school_id" filterable placeholder="请选择">
                        <el-option v-for="item in campus_school_list" :key="item.id" :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单状态:" prop="status">
                    <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                        :inactive-value="0" />

                </el-form-item>

                <el-form-item label="总金额:" prop="total">
                    <el-input-number v-model="editForm.total" controls-position="right" :min="0" :controls="false"
                        :precision="2" class="ele-fluid ele-text-left" placeholder="请输入总金额" clearable />
                </el-form-item>
                <el-form-item label="订单号:" prop="out_pay_num">
                    <el-input v-model="editForm.out_pay_num" placeholder="请输入订单号" clearable />
                </el-form-item>
                <el-form-item label="微信订单号:" prop="wx_pay_num">
                    <el-input v-model="editForm.wx_pay_num" placeholder="请输入微信订单号" clearable />
                </el-form-item>
                <el-form-item label="支付类型:" prop="pay_type">
                    <el-select v-model="editForm.pay_type" filterable placeholder="请选择支付类型">
                        <el-option label="微信" value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单类型:" prop="order_type">
                    <el-select v-model="editForm.order_type" filterable placeholder="请选择订单类型">
                        <el-option label="快递代取" value="1"></el-option>
                        <el-option label="专属跑腿" value="2"></el-option>
                        <el-option label="代买" value="3"></el-option>
                        <el-option label="洗鞋" value="4"></el-option>
                    </el-select>
                </el-form-item>


                <el-form-item label="加急金额:" prop="urgent_price">
                    <el-input-number v-model="editForm.urgent_price" controls-position="right" :min="0"
                        :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入加急金额"
                        clearable />
                </el-form-item>

                <el-form-item label="赏金:" prop="reward_price">
                    <el-input-number v-model="editForm.reward_price" controls-position="right" :min="0"
                        :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入赏金"
                        clearable />
                </el-form-item>

                <el-form-item label="回调数据:" prop="notify">
                    <el-input type="textarea" v-model="editForm.notify" placeholder="请输入回调数据" clearable />
                </el-form-item>

            </el-form>
            <div slot="footer">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapGetters
    } from "vuex";


    export default {
        name: "SysCampusBoxOrder",
        components: {},
        data() {
            return {
                table: {
                    url: '/campus/CampusBoxOrder/index',
                    where: {}
                }, // 表格配置
                choose: [], // 表格选中数据
                showEdit: false, // 是否显示表单弹窗
                editForm: {}, // 表单数据
                editFormTemp: {},
                admin_list: [],
                user_list: [],
                search_show: false,
                campus_school_list: [],
                user_openinfo_list: [],
                editRules: { // 表单验证规则

                    order_id: [{
                        required: true,
                        message: '请选择订单id',
                        trigger: 'blur'
                    }],


                    user_id: [{
                        required: true,
                        message: '请选择用户',
                        trigger: 'blur'
                    }],


                    school_id: [{
                        required: true,
                        message: '请选择学校',
                        trigger: 'blur'
                    }],



                    total: [{
                        required: true,
                        message: '请输入总金额',
                        trigger: 'blur'
                    }],


                    out_pay_num: [{
                        required: true,
                        message: '请输入订单号',
                        trigger: 'blur'
                    }],


                    wx_pay_num: [{
                        required: true,
                        message: '请输入微信订单号',
                        trigger: 'blur'
                    }],


                    pay_type: [{
                        required: true,
                        message: '请选择支付类型',
                        trigger: 'blur'
                    }],


                    order_type: [{
                        required: true,
                        message: '请选择订单类型',
                        trigger: 'blur'
                    }],


                    urgent_price: [{
                        required: true,
                        message: '请输入加急金额',
                        trigger: 'blur'
                    }],


                    reward_price: [{
                        required: true,
                        message: '请输入赏金',
                        trigger: 'blur'
                    }],



                    create_time: [{
                        required: true,
                        message: '请选择创建时间',
                        trigger: 'blur'
                    }],


                },
            }
        },
        computed: {
            ...mapGetters(["permission"]),
        },
        mounted() {

            this.userAllList();
            this.CampusSchoolAllList();
            this.UserOpeninfoAllList();
        },
        methods: {
            /**
             * 关闭
             */
            closeDialog() {
                this.showEdit = false;
                this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
            },
            /**
             * 显示编辑
             */
            edit(row) {
                this.$http.get('/campus/CampusBoxOrder/info?id=' + row.id).then(res => {
                    if (res.data.code === 0) {
                        this.showEdit = true;
                        setTimeout(() => {
                            this.editForm = res.data.data;
                        }, 100);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /**
             * 保存编辑
             */
            save() {
                this.$refs['editForm'].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/campus/CampusBoxOrder/edit', this.editForm).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.showEdit = false;
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    } else {
                        return false;
                    }
                });
            },
            /**
             * 刪除(批量刪除)
             */
            remove(row) {
                console.log(row)
                if (!row) { // 批量删除
                    if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                    let ids = this.choose.map(d => d.id);
                    this.$confirm('确定要删除选中的快递订单吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/campus/CampusBoxOrder/delete', {
                            id: ids
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }).catch(() => 0);
                } else { // 单个删除
                    const loading = this.$loading({
                        lock: true
                    });
                    this.$http.post('/campus/CampusBoxOrder/delete', {
                        id: row.id
                    }).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                            this.$refs.table.reload();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                }
            },

            /* 获取全部会员 */
            userAllList() {
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            /* 导出数据Excel */
            exportExcel() {
                let ids = this.choose.map(d => d.id)
                if (ids.length == 0) {
                    this.$message.error('请选择要导出的数据');
                    return false;
                }
                this.$http
                    .post("/campus/CampusBoxOrder/exportExcel", {
                        id: ids
                    })
                    .then((res) => {
                        let data = res.data;
                        if (data.code == 0) {
                            // 下载文件
                            window.location.href = data.data;
                            this.$message({
                                type: "success",
                                message: "导出成功",
                            });
                        } else {
                            this.$message.error("导出失败");
                        }
                    })
            },
            //查询其他信息
            CampusSchoolAllList() {
                this.$http.post('/campus/CampusSchool/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.campus_school_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },
            //查询其他信息
            UserOpeninfoAllList() {
                this.$http.post('/user/UserOpeninfo/allList', {}).then(res => {
                    if (res.data.code === 0) {
                        this.user_openinfo_list = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    this.$message.error(e.message);
                });
            },

            /**
     * 更改状态

     */
            editStatus(row, name) {
                const loading = this.$loading({
                    lock: true
                });
                let data = {
                    id: row.id,
                    name: name,
                    value: row[name],
        
      }
                this.$http.post("/campus/CampusBoxOrder/status", data).then(res => {
                    loading.close();
                    if (res.data.code === 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        });
                    } else {
                        row[name] = !row[name] ? 1 : 0;
                        this.$message.error(res.data.msg);
                    }
                }).catch(e => {
                    loading.close();
                    this.$message.error(e.message);
                });
            },
        }
    }
</script>

<style scoped>
    .ele-block>>>.el-upload,
    .ele-block>>>.el-upload-dragger {
        width: 100%;
    }
</style>
